module.exports = __webpack_public_path__ + "static/media/010-Begruessen_ID_17.4642b22a.mp3";